import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios';

import { API_BASE_URL } from '@/constants/config';
import i18n from '@/locales/i18n';

// Guest API client for signed URL endpoints (/guest/*).
//
// - baseURL: VITE_API_BASE_URL (NO /api prefix — guest routes are in routes/web.php)
// - No Authorization header
// - Automatically forwards ?signature=...&expires=... from window.location.search
// - Mirrors source/mobile/src/api/guestClient.ts

export const guestClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15_000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

guestClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const signature = params.get('signature');
    const expires = params.get('expires');
    if (signature) {
      config.params = { ...(config.params ?? {}), signature, expires };
    }
  }
  config.headers['Accept-Language'] = i18n.language ?? 'ru';
  return config;
});
